export default __webpack_public_path__ + "475fcc6ced44248774b844af9ee6f0b0.png";